(function () {
  function findQuantityInput(wrapper) {
    const formId = wrapper.getAttribute('data-product-form-id');
    if (!formId) return null;


    return (
      document.querySelector('input[name="quantity"][form="' + CSS.escape(formId) + '"]') ||
      document.querySelector('#' + CSS.escape(formId) + ' input[name="quantity"]')
    );
  }


  function formatMoney(cents, moneyFormat) {
    const amount = (cents / 100).toFixed(2);


    if (moneyFormat && moneyFormat.indexOf('{{amount}}') > -1) {
      return moneyFormat.replace('{{amount}}', amount);
    }


    return '£' + amount;
  }


  function setQuantity(input, value) {
    if (!input) return;


    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }


  function getPills(wrapper) {
    return Array.from(wrapper.querySelectorAll('[data-offer-pill]'));
  }


  function getSelectedPill(wrapper, currentQty) {
    const pills = getPills(wrapper);


    return pills.find(function (pill) {
      const qty = parseInt(pill.getAttribute('data-offer-qty') || '0', 10);
      return qty === currentQty;
    }) || null;
  }


  function updateMultiBuyUI(wrapper, currentQty) {
    const pills = getPills(wrapper);
    const compareEl = wrapper.querySelector('[data-multibuy-compare]');
    const finalEl = wrapper.querySelector('[data-multibuy-final]');
    const unitPrice = parseInt(wrapper.getAttribute('data-unit-price') || '0', 10);
    const moneyFormat = wrapper.getAttribute('data-money-format') || '£{{amount}}';


    if (!pills.length) return;


    let selectedPill = null;


    pills.forEach(function (pill) {
      const offerQty = parseInt(pill.getAttribute('data-offer-qty') || '0', 10);
      const isActive = currentQty === offerQty;


      pill.classList.toggle('is-active', isActive);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');


      if (isActive) {
        selectedPill = pill;
      }
    });


    if (!compareEl || !finalEl) return;


    if (!selectedPill || unitPrice <= 0) {
      compareEl.textContent = '';
      finalEl.textContent = '';
      return;
    }


    const selectedQty = parseInt(selectedPill.getAttribute('data-offer-qty') || '0', 10);
    const selectedDiscount = parseInt(selectedPill.getAttribute('data-offer-discount') || '0', 10);


    if (!selectedQty || !selectedDiscount) {
      compareEl.textContent = '';
      finalEl.textContent = '';
      return;
    }


    const originalTotal = unitPrice * selectedQty;
    const discountedTotal = Math.round((originalTotal * (100 - selectedDiscount)) / 100);


    compareEl.textContent = formatMoney(originalTotal, moneyFormat);
    finalEl.textContent = formatMoney(discountedTotal, moneyFormat);
  }


  document.addEventListener('click', function (event) {
    const pill = event.target.closest('[data-offer-pill]');
    if (!pill) return;


    const wrapper = pill.closest('[data-multibuy]');
    if (!wrapper) return;


    const input = findQuantityInput(wrapper);
    if (!input) return;


    const targetQty = parseInt(pill.getAttribute('data-offer-qty') || '0', 10);
    const currentQty = parseInt(input.value || '1', 10) || 1;


    if (!targetQty) return;


    if (currentQty === targetQty) {
      setQuantity(input, 1);
      updateMultiBuyUI(wrapper, 1);
    } else {
      setQuantity(input, targetQty);
      updateMultiBuyUI(wrapper, targetQty);
    }
  });


  document.addEventListener('input', function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.name !== 'quantity') return;


    document.querySelectorAll('[data-multibuy]').forEach(function (wrapper) {
      const linkedInput = findQuantityInput(wrapper);
      if (linkedInput === input) {
        updateMultiBuyUI(wrapper, parseInt(input.value || '1', 10) || 1);
      }
    });
  });


  document.addEventListener('change', function (event) {
    const target = event.target;


    if (target instanceof HTMLInputElement && target.name === 'quantity') {
      document.querySelectorAll('[data-multibuy]').forEach(function (wrapper) {
        const linkedInput = findQuantityInput(wrapper);
        if (linkedInput === target) {
          updateMultiBuyUI(wrapper, parseInt(target.value || '1', 10) || 1);
        }
      });
      return;
    }


    const variantChanged =
      target.matches('select[name="id"]') ||
      target.matches('input[name="id"]') ||
      target.matches('input[name="option1"]') ||
      target.matches('input[name="option2"]') ||
      target.matches('input[name="option3"]') ||
      target.matches('select[name="option1"]') ||
      target.matches('select[name="option2"]') ||
      target.matches('select[name="option3"]') ||
      target.closest('variant-picker') ||
      target.closest('product-variants');


    if (!variantChanged) return;


    document.querySelectorAll('[data-multibuy]').forEach(function (wrapper) {
      const input = findQuantityInput(wrapper);
      if (!input) return;


      setQuantity(input, 1);
      updateMultiBuyUI(wrapper, 1);
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-multibuy]').forEach(function (wrapper) {
      const input = findQuantityInput(wrapper);
      const currentQty = input ? (parseInt(input.value || '1', 10) || 1) : 1;


      updateMultiBuyUI(wrapper, currentQty);
    });
  });
})();